import React, { useState } from "react";
import "./Home.css";
import { useNavigate } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import Swal from "sweetalert2";

import Navbar from "./Navbar";

export default function Home() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Champs manquants",
        text: "Veuillez saisir votre email et mot de passe",
      });
      return;
    }

try {
   const response = await fetch("https://api.qunciland.com/api/login", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ email, password }),
});


      
const data = await response.json();
console.log("Réponse login :", data); 
if (data.user) {
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user); 
}
      // Sauvegarder le token et user dans le localStorage
      if (response.ok) {
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  

  setIsLoggedIn(true);

  Swal.fire({
    icon: "success",
    title: "Connexion réussie",
    text: `Bienvenue ${data.user.email}!`,
    confirmButtonText: "OK",
    customClass: {
      confirmButton: "swal-btn-ok"
    }
  }).then(() => {
    navigate("/");
  });
}
 else {
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: data.message,
        });
      }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      Swal.fire({
        icon: "error",
        title: "Erreur serveur",
        text: "Impossible de se connecter au serveur",
      });
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="home-container">
        <Navbar />
        <img
          src="/logo.png"
          alt="Logo Qunci"
          className="home-logo"
        />

        <div className="home-right">
          <h2>Connexion</h2>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <div className="password-input">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
            </span>
          </div>

          <button onClick={handleLogin}>Se connecter</button>
        </div>

       
      </div>
      
      
    );
    
  }
  return <div className="dashboard"></div>;
  
}
